import React, { useState, useEffect } from 'react';

import { BRANDS } from '../../helpers/renderOpenGraph/metaData/brands';
import './ProductBrandBanner.scss';

const ProductBrandBanner = () => {
  const [currentBrand, setCurrentBrand] = useState({});

  const detectPath = (currentPath, targetPath) =>
    currentPath?.includes(`/sg/en${targetPath}`) || currentPath?.includes(targetPath);

  const customShouldDisplay = title => {
    const now = new Date();
    const releaseTime = new Date('2025-05-26T10:00:00+08:00');
    const isPreProd = process.env.ENVIRONMENT === 'preprod';
    let shouldDisplay = true;

    if (title === `OWNDAYS × FREAK'S STORE`) {
      if (isPreProd) {
        return true;
      }
      const isBeforeRelease = now < releaseTime;
      if (isBeforeRelease) shouldDisplay = !isBeforeRelease;
    }

    return shouldDisplay;
  };

  useEffect(() => {
    const currentPath = window.location.pathname;
    const matchingBrand = BRANDS?.find(brand => detectPath(currentPath, brand.targetPath));

    if (matchingBrand) {
      setCurrentBrand(matchingBrand);
    } else {
      setCurrentBrand({});
    }
  }, []);

  useEffect(() => {
    if (Object.keys(currentBrand).length) {
      const separatorElements = document.getElementsByClassName('breadcrumb-separator');

      Array.from(separatorElements).forEach(element => {
        if (element.textContent === '/') {
          element.textContent = '>';
        }
      });
    }
  }, [currentBrand]);

  return Object.keys(currentBrand).length > 0 && customShouldDisplay(currentBrand.metaTitle) ? (
    <div
      className={`product-brand-banner ${
        currentBrand.isDarkTheme ? '' : 'product-brand-banner--light'
      }`}
    >
      <div className="product-brand-banner__bg">
        <picture>
          <source media="(min-width: 768px)" srcSet={currentBrand.bgPc} />
          <img
            alt={currentBrand.metaTitle}
            className="lazyload product-brand-banner__bg__img"
            src={currentBrand.bgSp}
          />
        </picture>
        <img
          alt={`logo-sp-${currentBrand.metaTitle}`}
          className="product-brand-banner__logo product-brand-banner__logo--sp"
          src={currentBrand.logo}
        />
      </div>

      <div className="product-brand-banner__details">
        <img
          alt={currentBrand.metaTitle}
          className="product-brand-banner__logo product-brand-banner__logo--pc"
          src={currentBrand.logo}
        />
        {currentBrand.title && (
          <>
            <h1 className="product-brand-banner__title">{currentBrand.title}</h1>
          </>
        )}
        <p className="product-brand-banner__text">{currentBrand.description}</p>
      </div>
    </div>
  ) : null;
};

export default ProductBrandBanner;
